module.exports = __webpack_public_path__ + "static/magic_hand-bc64c814dfe47be8222ffe74c727c87a.jpg";